// 2017-2026 MagicIslands.co.uk

import React, { Component } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";

import { MenuMobile } from "./components/Menu/Menu";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";

import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Careers from "./pages/Careers/Careers";
import Contacts from "./pages/Contacts/Contacts";
import Services from "./pages/Services/Services";
import Book from "./pages/Book/Book";
import "./Media.css";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.resizeEventListener = window.addEventListener(
      "resize",
      this.updateHeight
    );
  }

  changePage = (newPage) => {
    let state = this.state;
    state.mainBGClass = "main-container";
    state.fixedBGClass = "main-background-fixed main-background-" + newPage;
    this.setState(state);
    window.scrollTo(0, 0);
  };

  updateHeight = () => {
    let hmcf = document.getElementById("mainBgFixed");
    hmcf.style.height = window.innerHeight + "px";
  };

  componentDidMount(props) {
    this.updateHeight();
  }

  render() {
    return (
      <Router>
        <div className={this.state.mainBGClass}>
          <div id="mainBgFixed" className={this.state.fixedBGClass}></div>
          <Header />
          <Routes>
            <Route
              end
              path="/"
              element={<Home changePage={this.changePage} />}
            />

            <Route
              path="/about"
              element={<About changePage={this.changePage} />}
            />

            <Route
              path="/services"
              element={<Services changePage={this.changePage} />}
            />

            <Route
              path="/contacts"
              element={<Contacts changePage={this.changePage} />}
            />

            <Route
              path="/careers"
              element={<Careers changePage={this.changePage} />}
            />

            <Route
              path="/book"
              element={<Book changePage={this.changePage} />}
            />

            <Route element={<Home changePage={this.changePage} />} />
          </Routes>

          <MenuMobile changePage={this.changePage} />

          <Footer />
        </div>
      </Router>
    );
  }
}

export default App;
